export default __webpack_public_path__ + "static/media/avatar-child-girl.6b35eb6d.png";